// Couleurs de véhicule — liste unique Mbiyo (même liste que le serveur et les autres apps).
// On stocke le CODE ; l'étiquette suit la langue de l'app ; le hex teinte les pastilles/icônes.
export const VEHICLE_COLORS = [
  { code: 'white',    hex: '#FFFFFF', fr: 'Blanc',    en: 'White',    sw: 'Nyeupe',    ln: 'Mpɛmbɛ' },
  { code: 'black',    hex: '#1F2937', fr: 'Noir',     en: 'Black',    sw: 'Nyeusi',    ln: 'Moindo' },
  { code: 'gray',     hex: '#9CA3AF', fr: 'Gris',     en: 'Grey',     sw: 'Kijivu',    ln: 'Gris' },
  { code: 'silver',   hex: '#CBD5E1', fr: 'Argent',   en: 'Silver',   sw: 'Fedha',     ln: 'Argent' },
  { code: 'blue',     hex: '#2563EB', fr: 'Bleu',     en: 'Blue',     sw: 'Bluu',      ln: 'Bulé' },
  { code: 'red',      hex: '#EF4444', fr: 'Rouge',    en: 'Red',      sw: 'Nyekundu',  ln: 'Motane' },
  { code: 'yellow',   hex: '#FACC15', fr: 'Jaune',    en: 'Yellow',   sw: 'Njano',     ln: 'Jaune' },
  { code: 'green',    hex: '#16A34A', fr: 'Vert',     en: 'Green',    sw: 'Kijani',    ln: 'Mobesu' },
  { code: 'orange',   hex: '#F97316', fr: 'Orange',   en: 'Orange',   sw: 'Machungwa', ln: 'Orange' },
  { code: 'brown',    hex: '#92400E', fr: 'Marron',   en: 'Brown',    sw: 'Kahawia',   ln: 'Marron' },
  { code: 'beige',    hex: '#E7D3B3', fr: 'Beige',    en: 'Beige',    sw: 'Beige',     ln: 'Beige' },
  { code: 'purple',   hex: '#7C3AED', fr: 'Violet',   en: 'Purple',   sw: 'Zambarau',  ln: 'Violet' },
  { code: 'pink',     hex: '#EC4899', fr: 'Rose',     en: 'Pink',     sw: 'Waridi',    ln: 'Rose' },
  { code: 'bordeaux', hex: '#7F1D1D', fr: 'Bordeaux', en: 'Burgundy', sw: 'Bordeaux',  ln: 'Bordeaux' },
  { code: 'gold',     hex: '#D4AF37', fr: 'Doré',     en: 'Gold',     sw: 'Dhahabu',   ln: 'Wolo' },
  { code: 'other',    hex: '#374151', fr: 'Autre',    en: 'Other',    sw: 'Nyingine',  ln: 'Mosusu' },
];
const BY_CODE = Object.fromEntries(VEHICLE_COLORS.map(c => [c.code, c]));

/** Nom affiché (code → langue) ; une ancienne saisie libre est renvoyée telle quelle. */
export function vehicleColorLabel(code, lang = 'fr') {
  const c = BY_CODE[String(code || '').toLowerCase()];
  return c ? (c[lang] || c.fr) : (code || '');
}
export function vehicleColorHex(code) {
  return (BY_CODE[String(code || '').toLowerCase()] || BY_CODE.other).hex;
}
export const isKnownVehicleColor = (code) => !!BY_CODE[String(code || '').toLowerCase()];
